import { gql } from 'apollo-angular';

export const learningResourceLinkMinimal = gql`
  fragment LearningResourceLinkMinimal on LearningResourceLink {
    id
    title
    description
    url
    image {
      id
      url
    }
  }
`;
